export default __webpack_public_path__ + "static/2-32454df6f90002a817047927311c6c85.webp";